export default __webpack_public_path__ + "static/media/wall-for-women-logo.74202471.png";